__turbopack_context__.v({
  "fixed": "Tabs-module-scss-module__nMORQG__fixed",
  "scrollable": "Tabs-module-scss-module__nMORQG__scrollable",
  "tabs": "Tabs-module-scss-module__nMORQG__tabs",
});
